// §7 Onboarding stepper — back arrow, "Step X of 8", step name, 8 circles.
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import '../onboarding.css';

export const STEP_NAMES = [
  'Product selection',
  'Personal details',
  'SMS verification',
  'Email verification',
  'Identity verification',
  'Signature capture',
  "Let's get to know you",
  'Assisted by',
];

interface OnboardingLayoutProps {
  step: number; // 2-8 (step 1 is the chooser screen)
  heading: string;
  backTo: string;
  children: ReactNode;
}

const OnboardingLayout = ({ step, heading, backTo, children }: OnboardingLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="nova-ob-page nova-ob-page-full">
      <div className="nova-ob-navbar">
        <div className="brand">
          <span className="mark">N</span>
          <span>NovaBank</span>
        </div>
        <span className="text-muted" style={{ fontSize: '0.85rem' }}>Account opening</span>
      </div>

      <div className="nova-ob-header">
        <button type="button" className="nova-ob-back" aria-label="Back" onClick={() => navigate(backTo)}>
          ←
        </button>
        <div className="nova-ob-step-meta mt-1">
          Step {step} of 8 · {STEP_NAMES[step - 1]}
        </div>
        <div className="nova-ob-stepper" aria-hidden="true">
          {Array.from({ length: 8 }).map((_, i) => {
            const n = i + 1;
            const stateClass = n < step ? 'done' : n === step ? 'current' : '';
            return (
              <span key={n} style={{ display: 'flex', alignItems: 'center' }}>
                {i > 0 && <span className={`nova-ob-step-line ${n <= step ? 'done' : ''}`} />}
                <span className={`nova-ob-step ${stateClass}`}>
                  {n < step ? '✓' : n}
                </span>
              </span>
            );
          })}
        </div>
      </div>

      <div className="nova-ob-body">
        <div className="nova-ob-panel">
          <h1 className="nova-ob-heading">{heading}</h1>
          {children}
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
